import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: '/',
  routes: [
    {
      path: '/',
      redirect: '/chat'
    }, {
      path: '/chat',
      name: 'Chat',
      component: () => import('@/pages/chat/main.vue')
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js